import {
    TNS3ND_CONTEXT,
    isEnableCdn,
    parseURL,
    loadRemoteScript as _loadRemoteScript2,
    getTnsSdkScriptSrc,
    createSinglePromise,
    debugLog
} from "./utils/loadResources";
import luaApi from "./api/luaApi";
import {CookieHelper} from "./xscf";
// 自定义分组分隔符 webGroup.DataTable
const GROUP_SEPARATOR = '.';

declare global {
    interface Window{
        tnsSdk:any;
        TNS_BASE_HOST:string;
        TNS_OFFLINE_HOST: string;
        TNS_OFFLINE_PKG_PATH: string;
        TNS2ND_SHARE_SCOPE:string;
        load2ndLangResource:any;
        cdn_privateHost: string;

    }
}
/** @deprecated 使用TNSClientPlugin.replacePackages配置代替 */
const OLD_TO_NEW = {
    "ynf-lib-basic": "ynf-lib-base",
    "ynf-lib-layout": "ynf-lib-base",
    "ynf-lib-dataentry": "ynf-lib-base",
    "ynf-lib-view": "ynf-lib-base",
    "ynf-lib-nav": "ynf-lib-base",
    "ynf-lib-feedback": "ynf-lib-base",
    "ynf-lib-basic-mobile": "ynf-lib-base-mobile",
    "ynf-lib-layout-mobile": "ynf-lib-base-mobile",
    "ynf-lib-dataentry-mobile": "ynf-lib-base-mobile",
    "ynf-lib-view-mobile": "ynf-lib-base-mobile",
    "ynf-lib-nav-mobile": "ynf-lib-base-mobile",
    "ynf-lib-feedback-mobile": "ynf-lib-base-mobile",
    "ynf-core-store": 'ynf-core-engine',
    "ynf-core-renderer": 'ynf-core-engine',
    "ynf-core-runtime": 'ynf-core-engine',
    "ynf-fw-bill-api": 'ynf-core-engine',
    "ynf-fw-query-lib": 'ynf-fw-apcom-lib',
    "ynf-fw-refer-lib": 'ynf-fw-apcom-lib',
    "ynf-fw-apcom-lib": 'ynf-fw-apcom-lib',
    "ynf-fw-query-mobile-lib": 'ynf-fw-apcom-mobile-lib',
    "ynf-fw-refer-mobile-lib": 'ynf-fw-apcom-mobile-lib',
    "ynf-fw-apcom-mobile-lib": 'ynf-fw-apcom-mobile-lib',
}
// 内存缓存
const LOCAL_CACHE = {
    // ajaxIsLoaded:{},
    pkgVersions:{
        /**环境编码:{资源编码:版本号}**/
    },
    // ynf二方包新旧包名称映射
    replacePackages: {},
    packageNameWithInfo : {}, // 包名对应的包信息
    allProviders: {}, // 全部二方包版本
};

const convertOldToNew = (replacePackages) => {
    const packageMap = {}
    Object.entries(replacePackages).forEach(([key, value]) => {
        value && (value as Array<any>).forEach(v => {
            if (packageMap[v]) {
                console.error('[TNE]发现存在重复的合包情况' + packageMap[v] + '和' + key + '都会对' + v + '有合包现象')
            }
            packageMap[v] = key;
        });
    })
    return packageMap;
}

// 获取服务化二方包的版本号
// 内部包含 合包 逻辑
async function fetchCacheProviderPackage(providerPackage:string, isCdn:boolean){
    // 1.优先从运行时缓存获取
    LOCAL_CACHE.replacePackages = LOCAL_CACHE.replacePackages || {};
    LOCAL_CACHE.pkgVersions = LOCAL_CACHE.pkgVersions || {};
    // 目前tne2nd做与ynf二方包新旧包映射
    let pkg = LOCAL_CACHE.replacePackages[providerPackage];
    let pVersion = LOCAL_CACHE.pkgVersions[pkg];
    let mini = LOCAL_CACHE.allProviders[pkg]?.mini;
    if (pVersion)return { version: pVersion, name: pkg, mini };
    // 2.其次从服务注册中心获取
    let {
        providers = {},
        replacePackages: replaceablePackages,
        allProviders
    } = await luaApi.asyncFetchCacheProviderPackages();
    // delete replaceablePackages['ynf-fw-designer-lib']
    let repPackages;
    if (replaceablePackages) {
        repPackages = convertOldToNew(replaceablePackages);
        Object.assign(LOCAL_CACHE.replacePackages, repPackages); // 更新运行时缓存
    }
    Object.assign(LOCAL_CACHE.allProviders, allProviders); // 更新运行时缓存
    // debugLog('AAA--fetchCacheProviderPackage---6---》'+providerPackage);
    Object.assign(LOCAL_CACHE.pkgVersions, providers); // 更新运行时缓存
    pkg = LOCAL_CACHE.replacePackages[providerPackage] || providerPackage;
    pVersion =  LOCAL_CACHE.pkgVersions[pkg]
    mini = LOCAL_CACHE.allProviders[pkg]?.mini;
    // debugLog('AAA--fetchCacheProviderPackage---7---》'+providerPackage);
    if(pVersion){
        // debugLog('AAA--fetchCacheProviderPackage---7.1---》'+providerPackage);
        return {version: pVersion, name: pkg, mini};
    }
    if (!isCdn){
        // debugLog('AAA--fetchCacheProviderPackage---7.2---》'+providerPackage);
        return {version: "", name: pkg, mini};
    }
    try{
        // 3.降级从相对域名下获取项目version.json中的版本号
        // debugLog('AAA--fetchCacheProviderPackage---8.1---》'+providerPackage);
        let versionUrl = `/${pkg}/ucf-wh/version.json`;

        let versionResp = await fetch(versionUrl);
        // debugLog('AAA--fetchCacheProviderPackage---8.2---》'+providerPackage);
        let versionFile = await versionResp.json();
        pVersion = versionFile && versionFile.version;
        mini = versionFile && versionFile.ucf_res ? true : false;
        // debugLog('AAA--fetchCacheProviderPackage---8.3---》'+providerPackage);
        if(pVersion){
            // debugLog('AAA--fetchCacheProviderPackage---8.4---》'+providerPackage);
            LOCAL_CACHE.pkgVersions[pkg] = pVersion;    // 更新运行时缓存
            return {version: pVersion, name: pkg, mini};
        }else{
            // debugLog('AAA--fetchCacheProviderPackage---8.5---》'+providerPackage);
            return {version: "", name: pkg, mini};
        }
    }catch (e) {
        // debugLog('AAA--fetchCacheProviderPackage---8.6---》'+providerPackage);
        console.warn('[TNE]'+pkg+'版本信息(空)，已降级处理', e);
        return {version: "", name: pkg, mini: true};
    }
}
/**
 * 将输入字符串按分隔符进行转化为首字母大写，例如: 输入"my-base-core" 输出"MyBaseCore"
 * @param str
 * @param splitKey
 * @return {string|*}
 */
function convertFirstLetterToUpperCase(str,splitKey) {
    if(!str || !splitKey)return str; // 参数不存在则返回原始str
    if(!str.indexOf(splitKey))return str; // 分隔符不存在则返回原始str
    let splitStr = str.toLowerCase().split(splitKey);
    for (let i = 0; i < splitStr.length; i++) {
        if(splitStr[i].length > 0){
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
    }

    return splitStr.join('');
}

/**
 * 获取包信息（包含：旧包名转换为最终包名称）
 * @return {
 *  packageName:"ynf-core-engine" // 最新包名
 *  providerName:"YnfCoreEngine"
 *  sourcePackageName 原始包名｜旧包名
 *  isSame 是否跟tnsSdk保持同源策略
 *  mini: true 是否生成小程序资源 ucf-res的zip
 * }
 */
export async function asyncSinglePackageInfo(
    packageName: string,
): Promise<{
    sourcePackageName;
    packageName: string;
    providerName: string;
    version: string;
    isCdn: boolean;
    isSame: boolean;
}> {
    async function createPackageInfoPromise() {
        const tnsSdkUrl = getTnsSdkScriptSrc();
        const tnsSdkUrlInfo = parseURL(tnsSdkUrl);
        const same = tnsSdkUrlInfo.params.same; // url参数：是否跟tnsSdk保持同源
        const cdn = tnsSdkUrlInfo.params.cdn; // url参数：是否禁用cdn
        const isCdn = cdn!=='false' && isEnableCdn();
        let pkgName = packageName;
        if(OLD_TO_NEW[pkgName]) {
            pkgName = OLD_TO_NEW[pkgName]
        }
        // 适配协同H5页面，提前请求接口
        if(isCdn){
            let context = await luaApi.asyncFetchContext();
        }
        const {
            version,
            name,
            mini,
        } = await createSinglePromise(
            "asyncPackageInfo.fetchCacheProviderPackage." + packageName,
            () => fetchCacheProviderPackage(pkgName, isCdn)
        ); // 单例promise
        // const {version, name} = await fetchCacheProviderPackage(pkgName, isCdn); // 旧方式存在问题，会产生多个实例
        pkgName = name;
        const proName = convertFirstLetterToUpperCase(pkgName, "-");
        return {
            sourcePackageName: packageName,
            packageName: pkgName,
            providerName: proName,
            version,
            isCdn,
            isSame: same,
            mini: mini ? true : false,
        };
    }
    return await createSinglePromise("asyncPackageInfo."+packageName,()=>createPackageInfoPromise())
}

/**
 * 异步加载服务化二方包资源入口，提供给TNSRemotePlugin动态生成代码使用。
 * 加载优先级 CDN > same > TNS_BASE_HOST > 默认相对路径
 */
export async function asyncLoadPackage(options:{providerPackage:string,providerName?:string,loadBy?:string,forceReload?:boolean}){
    const pkgInfo = await asyncSinglePackageInfo(options.providerPackage); // 获取包相关信息，新旧包使用一个promise单例。
    return await createSinglePromise("asyncLoadPackage."+pkgInfo.packageName,()=>asyncLoad2ndPackage(options,pkgInfo));
}
async function asyncLoad2ndPackage(options:{providerPackage:string,providerName?:string,loadBy?:string,forceReload?:boolean},pkgInfo:any){
    let {providerPackage,providerName,loadBy,forceReload = false} = options ||{}; //providerName: "YnfLibLayout", providerPackage: "ynf-lib-layout"
    if(!providerPackage){
        console.error(`Loading script failed unknown providerPackage`);
        return;
    }
    providerPackage = pkgInfo.packageName;
    let proName = pkgInfo.providerName;
    let loadError = new Error();
    let loadUrl = "";
    // mini = true继续加载file协议，false为加载cdn协议
    let mini = pkgInfo.mini;
    try{
        if (pkgInfo.isCdn) { // 开启了CDN
            // 默认获取替换后的cdn域名
            let cdnHost = parseURL(TNS3ND_CONTEXT).hostDomain;
            // 上下文返回的cdn域名优先级最高
            let context = await luaApi.asyncFetchContext();
            if(context && context.cdnHost) cdnHost = context.cdnHost;
            // 获取全部二方包版本
            if(pkgInfo.version && cdnHost){ // 走CDN对应版本的资源
                loadUrl = `${cdnHost}/static/ucf/${providerPackage}/${pkgInfo.version}/${proName}.js`;
            }
        }
        if(!loadUrl){ // 未开启CDN、未找到CDN资源版本则降级走相对域名
            let currHost = '';
            if(window.TNS_BASE_HOST){
                currHost = window.TNS_BASE_HOST; //存在全局指定域名host则用否则使用相对域名
            }else if(pkgInfo.isSame){// 跟tnsSdk.js同源加载，一般跨域名门户和移动离线file:///协议模式 需要由此兼容
                //TODO  ${cdnHost}/release/tnsSdk.js 同源是固定cdn域名时不支持，独立域名时支持
                const tnsSdkUrl = getTnsSdkScriptSrc();
                const sameHost = tnsSdkUrl.substring(0,tnsSdkUrl.indexOf('/iuap-tns/ucf-wh/'));
                currHost = sameHost; //使用tnsSdk同源host
                 // todo 判断file协议加载是否存在`${currHost}/${providerPackage}/ucf-wh/${proName}.js`;
                // 使用XMLHttpRequest检测资源是否存在
                function checkLocalResource(url): Promise<boolean> {
                    return new Promise((resolve) => {
                        const xhr = new XMLHttpRequest();
                        xhr.open('HEAD', url, true);
                        xhr.onreadystatechange = function() {
                            if (xhr.readyState === 4) {
                                resolve(xhr.status === 200);
                            }
                        };
                        xhr.onerror = () => resolve(false);
                        xhr.send();
                    });
                }
                // 对于file协议，检测资源是否存在
                const resourceUrl = `${currHost}/${providerPackage}/ucf-wh/${proName}.js`;
                if (mini && resourceUrl.startsWith('file://') && window.location.origin.startsWith('file://')) {
                    try {
                        const resourceExists = await checkLocalResource(resourceUrl);
                        if (!resourceExists) {
                            // 资源不存在，设置mini=false，走在线加载
                            mini = false;
                            console.warn(`[TNE] 检测到本地离线资源不存在，将采用在线方式拉取 【${providerPackage}】资源`)
                        }
                    } catch (err) {
                        // 异常情况也认为资源不存在，设置mini=false
                        mini = false;
                        console.warn(`[TNE] 检测离线资源异常,将采用在线方式拉取 【${providerPackage}】资源：`, err);
                    }
                }
                // 适配协同单包离线应用，二方包路径加载路径不一致，需要适配
                if(window.TNS_OFFLINE_PKG_PATH) {
                    currHost = window.TNS_OFFLINE_PKG_PATH;
                }
            }
            // 专属化支持cdn域名加载
            if(!isEnableCdn() && window.cdn_privateHost && providerPackage !== 'iuap-gp-ymscloudui-fe'){
                currHost = window.cdn_privateHost;
            }
            //V3R6及之后的专属化版本加载二方包默认开启强缓存
            if (pkgInfo.version && !pkgInfo.isSame && !isEnableCdn()) {
                //loadUrl = `${currHost}/${providerPackage}/ucf-wh/${proName}.js`;
                loadUrl = `${currHost}/${providerPackage}/ucf-wh/${pkgInfo.version}/${proName}.js`;
            } else {
                loadUrl = `${currHost}/${providerPackage}/ucf-wh/${proName}.js`;
            }
            // 离线资源情况下 mdf会set变量
            if (window.TNS_OFFLINE_HOST) {
                let context = await luaApi.asyncFetchContext();
                let cdnHost = "";
                if (context && context.cdnHost) cdnHost = context.cdnHost;
                // mini为false，会加载cdn资源
                if (mini === false) {
                    // 获取全部二方包版本
                    // 断网离线环境mini也为false，不能走相对域名，获取到版本号则不为断网
                    if (pkgInfo.version){
                        if (cdnHost) {
                            // 走CDN对应版本的资源
                            loadUrl = `${cdnHost}/static/ucf/${providerPackage}/${pkgInfo.version}/${proName}.js`;
                        }else{
                            //V3R6及之后的专属化版本加载二方包默认开启强缓存
                            if (pkgInfo.version && !pkgInfo.isSame) {
                                //loadUrl = `${window.TNS_OFFLINE_HOST}/${providerPackage}/ucf-wh/${proName}.js`;
                                loadUrl = `${window.TNS_OFFLINE_HOST}/${providerPackage}/ucf-wh/${pkgInfo.version}/${proName}.js`;
                            } else {
                                loadUrl = `${window.TNS_OFFLINE_HOST}/${providerPackage}/ucf-wh/${proName}.js`;
                            }
                        }
                    }
                }
            }
        }

        let loadProvider = new Promise((resolve, reject) => {
            debugLog("[TNE]---load2nd--1.0-准备--" + loadUrl);
            // 已存在则不需要再加载
            if (typeof window[proName] !== "undefined") {
                // @ts-ignore
                if (window.TNS2ND_SHARE_SCOPE === window[proName].scope) {  // 当前二方包资源共享范围与小应用的不一致时需重新加载
                    if(forceReload===false) {
                        debugLog("[TNE]---load2nd--1.2-已存在-范围相同-无需加载-" + loadUrl, window[proName]);
                        resolve(window[proName]);
                        return;
                    }else{
                        // @ts-ignore
                        window[proName].scope = __webpack_share_scopes__.default;
                        debugLog("[TNE]---load2nd--1.2-已存在-范围相同-强制重新加载-" + loadUrl, window[proName]);
                    }
                } else {
                    debugLog("[TNE]---load2nd--1.2-已存在-范围不同-重新加载" + loadUrl, window[proName]);
                }
            }
            debugLog("[TNE]---load2nd--1.1-开始--" + loadUrl);
            _loadRemoteScript2(loadUrl, (event)=> {
                let remoteModule = window[proName];
                debugLog("[TNE]---load2nd--1.3-结束--" + loadUrl, remoteModule);
                if (!remoteModule) { //实例不存在则直接返回错误
                    let errorType = event && (event.type === 'load' ? 'missing' : event.type);
                    let realSrc = event && event.target && event.target.src;
                    loadError.message = 'Loading script failed(二方包实例获取失败,请检查入口文件挂载情况).\n(' + errorType + ': ' + realSrc + ')';
                    loadError.name = 'ScriptExternalLoadError';
                    // @ts-ignore
                    loadError.type = errorType;
                    // @ts-ignore
                    loadError.request = realSrc;
                    // console.error(`二方包实例【${proName}】获取失败：${event}`);
                    reject(loadError);
                } else {// 实例存在则判断是否要加载多语资源，否则直接返回实例
                    // @ts-ignore
                    remoteModule.scope = window.TNS2ND_SHARE_SCOPE;
                    // remoteModule.scope = __webpack_share_scopes__.default;
                    // @ts-ignore
                    remoteModule.packageInfo = pkgInfo;
                    // @ts-ignore
                    remoteModule.loadBy = loadBy;

                    //await __webpack_init_sharing__('default');
                    //await remoteModule.init(__webpack_share_scopes__.default);

                    // if (!remoteModule.__initialized) {
                    //     // if share scope doesnt exist (like in webpack 4) then expect shareScope to be a manual object
                    //     // var wShareScope = (typeof __webpack_share_scopes__ === 'undefined')?shareScope.default:__webpack_share_scopes__[shareScope];
                    //     let wShareScope = "default";
                    //     if (__webpack_share_scopes__ && __webpack_share_scopes__[wShareScope]) {
                    //         // use default share scope object passed in manually
                    //         wShareScope = __webpack_share_scopes__[wShareScope];
                    //     } else {
                    //         // otherwise, init share scope as usual
                    //         wShareScope = __webpack_share_scopes__;
                    //     }
                    //     let initResult = remoteModule.init(wShareScope);
                    //     if(initResult === 1){ // 无其它异步资源依赖的情况会返回 1
                    //         remoteModule.__initialized = true;
                    //         resolve(remoteModule);
                    //     }else if(initResult.then){ // 存在其它异步资源依赖的情况会返回 Promise
                    //         initResult.then(()=>{
                    //             remoteModule.__initialized = true;
                    //             resolve(remoteModule);
                    //         })
                    //     }
                    // }

                    // 二方包入口返回给业务之前，触发一次二方包多语资源加载
                    // @ts-ignore
                    if (typeof window.load2ndLangResource == 'function' && remoteModule.Global) {
                        // @ts-ignore
                        let langResourceParams = Object.assign({providerPackage:providerPackage,providerName:proName}, remoteModule.Global);
                        window.load2ndLangResource(langResourceParams).then().finally(function () {
                            resolve(remoteModule);
                        })
                    } else {
                        resolve(remoteModule);
                    }
                }
            }, proName);
        })
        return loadProvider;
    }catch(error){
        console.error(error,`Loading script failed ${loadUrl}`,pkgInfo);
    }
}

/**
 * 异步引入二方包或组件
 * @param pathString ，用法类似原生import()语法，例如： asyncImport("ynf-fw-formula-api") / asyncImport("ynf-fw-formula-api/Button")
 * 供ynf-core-loader的loadYNF使用
 */
export async function asyncImport (pathString:string):Promise<any> {
    try {
        // debugLog('AAA-----asyncImport--加载二方包-->'+pathString);
        const splitIndex = pathString.indexOf('/')
        const packageName = ~splitIndex ? pathString.substring(0, splitIndex) : pathString // 包名
        const packageInfo = await asyncSinglePackageInfo(packageName); // 获取包相关信息
        // const providerName = packageInfo.providerName;
        const entry = ~splitIndex ? `./${pathString.substring(splitIndex + 1)}` : '.' // 入口名
        const container = await window.tnsSdk.asyncLoadPackage({ providerPackage: packageInfo.packageName, providerName: packageInfo.providerName, loadBy:'asyncImport' })
        // await __webpack_init_sharing__('default')
        // const container = window[providerName]
        // if (!container) throw new Error('')
        // await container.init(__webpack_share_scopes__.default)
        if (!container) return;
        const cleanEntry = entry.startsWith("./")
        ? entry.substring(2)
        : entry;
        // 自定义分组下的组件
        if (entry.startsWith("./") && cleanEntry.includes(GROUP_SEPARATOR)) {
            const componentParts = cleanEntry.split(GROUP_SEPARATOR);
            // 提取分组名称
            const groupEntry = componentParts[0];
            // 提取组件
            const componentName = componentParts.slice(1).join(GROUP_SEPARATOR);
            const factory = await container.get(`./${groupEntry}`);
            let Module = factory();
            return Module?.[componentName]; // 自定义分组下获取单个组件
        } else {
            const factory = await container.get(entry);
            let Module = factory()
            return (Module?.default) ? Module.default : Module;
        }
    } catch (error) {
        console.warn(`%casyncImport failed ${pathString}：\n`, "font-size:18px", error);
    }
}


/**
 * 异步加载二方包组件库下的组件
 * @param packageName  二方包名 例如：“ynf-tinper-next-pro”
 * @param componentEntry 组件名｜组件入口名 例如：“Button” ｜“./Button”
 * 供ynf-core-loader的YNFLoader使用
 */
export async function asyncLoadComponent (packageName:string, componentEntry:string, isPreferIndependent?):Promise<any> {
    const packageInfo = await asyncSinglePackageInfo(packageName); // 获取包相关信息
    const providerName = packageInfo.providerName;
    const providerEntry = componentEntry.startsWith('./') ? componentEntry : ('./' + componentEntry); // 将"Button" 补充为 "./Button" ，如果带"./" 则无需处理
    debugLog('[TNE]---asyncLoadComponent---->'+packageName+"!"+componentEntry)
    const container = await window.tnsSdk.asyncLoadPackage({ providerPackage: packageInfo.packageName, providerName: packageInfo.providerName, loadBy:'asyncImport' })
    // await __webpack_init_sharing__('default')
    // const container = window[providerName]
    if (!container) throw new Error('')
    // await container.init(__webpack_share_scopes__.default)

    let RemoteComponent: any;
    const moduleDefault = (m) => (m && m.default ? m.default : m); // 存在default优先取default
    const cleanEntry = providerEntry.split("./")[1];
    // 如果带 .  就认为为自定义分组来加载
    if (cleanEntry.includes(GROUP_SEPARATOR)) {
        const componentParts = cleanEntry.split(GROUP_SEPARATOR);
        // 提取分组名称
        const groupEntry = componentParts[0];
        // 提取组件
        const componentName = componentParts.slice(1).join(GROUP_SEPARATOR);
        try {
            const entryAllFactory = await window[providerName]?.get(
                `./${groupEntry}`
            );
            let Module = entryAllFactory();
            RemoteComponent = Module?.[componentName]; // 自定义分组下获取单个组件
        } catch (error) {
            console.error(`[TNE] Error loading remote component: ${error}`);
        }
     } else {
        // 是否优先独立入口加载
        if(isPreferIndependent){
            try {
                // 情况1:单个入口"./providerEntry"存在，优先从单个获取
                const entryCompFactory = await window[providerName].get(providerEntry);
                RemoteComponent = entryCompFactory();
                RemoteComponent = moduleDefault(RemoteComponent);
            } catch (error) { // 可能获取主入口或单个入口异常
                console.log(`单个入口"./${providerEntry}"不存在,此时尝试从主入口获取`);
                CookieHelper.read("tnsDebug") && console.error(`${error}`);
                // 情况2:单个入口不存在，则从主入口“.”下获取单个组件
                let bundleName = providerEntry.startsWith('./') ? providerEntry.replace(/^\.\//, '') : providerEntry; // 将"./Button" 还原为 "Button"
                const entryAllFactory = await window[providerName].get("."); // 优先取主入口模块
                let Module = entryAllFactory();
                Module = moduleDefault(Module);
                RemoteComponent = Module?.[bundleName];// 主入口下获取单个组件
            }
        }else{
            try {
                // 情况1:主入口存在，且有暴露单个模块
                let bundleName = providerEntry.startsWith('./') ? providerEntry.replace(/^\.\//, '') : providerEntry; // 将"./Button" 还原为 "Button"
                const entryAllFactory = await window[providerName].get("."); // 优先取主入口模块
                let Module = entryAllFactory();
                Module = moduleDefault(Module);
                RemoteComponent = Module?.[bundleName];// 主入口下获取单个组件
                // 情况2:主入口存在，但未暴露单个模块，此时尝试从单个入口获取
                if (!RemoteComponent) {
                    const entryOneFactory = await window[providerName].get(providerEntry);
                    RemoteComponent = entryOneFactory();
                    RemoteComponent = moduleDefault(RemoteComponent);
                }
            } catch (error) { // 可能获取主入口或单个入口异常
                // 情况3:主入口"."不存在，则会报错，此时尝试从单个入口获取
                console.log(`主入口"."不存在，则会报错，此时尝试从单个入口获取！${error}`);
                CookieHelper.read("tnsDebug") && console.error(`${error}`);
                const entryCompFactory = await window[providerName].get(providerEntry);
                RemoteComponent = entryCompFactory();
                RemoteComponent = moduleDefault(RemoteComponent);
            }
        }
    }
    if(!RemoteComponent){
        console.error(`%c加载组件失败，请检查包[${packageName}]是否导出组件[${componentEntry}]或组件本身是否发生异常！\n`, "font-size:18px");
    }
    return RemoteComponent;
}


// const loadPromiseCachedOld = {}
// //-----------以下为旧版本的降级方法，不再推荐使用，建议引入tnsSdk.js的方法-------------
// export async function asyncLoadComponentOld(sysCode, entry) {
//     const providerEntry = entry.includes('./') ? entry : ('./' + entry);
//
//     function toCamelCase(str) {
//         return str.replace(/-([a-z])/g, function (match, letter) {
//             return letter.toUpperCase();
//         }).replace(/-/g, '').replace(/^\w/, function (letter) {
//             return letter.toUpperCase();
//         });
//     }
//
//     // await __webpack_init_sharing__('default')
//     let containerPromise = loadPromiseCachedOld[sysCode]
//     if (!containerPromise) {
//         containerPromise = loadPromiseCachedOld[sysCode] = window.tnsSdk.asyncLoadPackage({
//             providerPackage: sysCode,
//             providerName: toCamelCase(sysCode)
//         });
//     }
//     const container = await containerPromise;
//     // await container.init(__webpack_share_scopes__.default);
//     let loadComponetRes;
//     try {
//         const factory = await container.get(".");
//         const bunleName = providerEntry.includes('./') ? providerEntry.replace(/^\.\//, '') : providerEntry
//         loadComponetRes = factory()?.[bunleName]
//         if (!loadComponetRes) {
//             const factory = await container.get(providerEntry);
//             loadComponetRes = factory()
//         }
//     } catch (error) {
//         console.error(error);
//         const factory = await container.get(providerEntry);
//         loadComponetRes = factory()
//     }
//
//     return loadComponetRes;
// }


// 创建一个 Map 来缓存已加载的资源
const loadedResources = new Map<string, boolean>();
async function _loadRemoteScript({ tne2ndName, path, callback, type }) {
    if (!tne2ndName || !path) {
        console.error("【TNE】tne2ndName和path不能为空");
        return;
    }
    const pkgInfo = await asyncSinglePackageInfo(tne2ndName);
    let url = "";
    if (pkgInfo.isCdn) {
        let cdnHost = parseURL(TNS3ND_CONTEXT).hostDomain;
        // 上下文返回的cdn域名优先级最高
        let context = await luaApi.asyncFetchContext();
        if (context && context.cdnHost) cdnHost = context.cdnHost;
        if(pkgInfo.version){
            url = `${cdnHost}/static/ucf/${tne2ndName}/${pkgInfo.version}/${path}`;
        }
    }
    if (!url) {
        let currHost = "";
        if (window.TNS_BASE_HOST) {
            currHost = window.TNS_BASE_HOST; //存在全局指定域名host则用否则使用相对域名
        }
        url = `${currHost}/${tne2ndName}/ucf-wh/${path}`;
    }
    
    // 检查资源是否已缓存
    if (loadedResources.has(url)) {
        console.log(`【TNE】服务化二方包: ${tne2ndName}已加载成功,不再重复加载`);
        return; // 如果已缓存，直接返回，不再重复加载
    }else{
        loadedResources.set(url, true);
    }
    if (type === "link") {
        const link = document.createElement("link");
        link.rel = "stylesheet"; // 默认为 "text/javascript"
        link.type = "text/css";
        link.href = url; // 安全的设置 script 的 src 属性
        document.head.appendChild(link);
        link.onload = () => {
            console.log(`【TNE】${tne2ndName}: ${path} 服务化组件已加载成功`);
        };
        link.onerror = (err) => {
            loadedResources.delete(url);
            console.log(`【TNE】${tne2ndName}: ${path} 服务化组件加载失败`, err);
        };
    } else {
        // 创建新的 script 元素
        const script = document.createElement("script");
        script.type = "text/javascript"; // 默认为 "text/javascript"
        script.src = url; // 安全的设置 script 的 src 属性
        // 当 script 加载成功时执行的回调函数
        script.onload = () => {
            console.log(`【TNE】${tne2ndName}: ${path} 服务化组件已加载成功`);
            // 资源加载完成后，将其添加到缓存中
            if (callback) callback();
        };
        script.onerror = (err) => {
            loadedResources.delete(url);
            console.log(`【TNE】${tne2ndName}: ${path} 服务化组件加载失败`, err);
        };
        // 将 script 元素添加到 DOM 中，开始加载
        document.body.appendChild(script);
    }
}

// 加载原tag模式的js，需要挂载到window上
export async function loadRemoteScript(tne2ndPkg) {
    if (!tne2ndPkg) {
        return console.error("参数不能为空");
    } else {
        if (Array.isArray(tne2ndPkg)) {
            tne2ndPkg.forEach((item) => {
                _loadRemoteScript(item);
            });
        } else {
            _loadRemoteScript(tne2ndPkg);
        }
    }
}


export async function asyncGetPackageMetaInfo(name) {
  let pkgInfo = await asyncSinglePackageInfo(name);
  let { packageName } = pkgInfo;
  let allMetaData;
  try {
    allMetaData = await luaApi.asyncFetchProjectMetaInfos(packageName);
  } catch (error) {
    console.warn(`【TNE】 ${error}`);
  }
  if (allMetaData && allMetaData[packageName]) {
    return {
      ...pkgInfo,
      providerEntry: allMetaData[packageName].providerEntry,
    };
  } else {
    console.warn(`【TNE】${name}组件元数据不存在`);
    return pkgInfo;
  }
}